export default __webpack_public_path__ + "static/media/cake.c88fffbc.jfif";